export interface Show {
  id: string;
  title: string;
  type: "movie" | "tvshow";
  genres: string[];
  region: string;
  year: number;
  rating: number | null;
  director: string;
  actors: string[];
  synopsis: string;
  cover: string;
  popularity: number;
  releaseDate: string;
  topics: string[];
}

export const shows: Show[] = [
  {
    id: "interstellar-night",
    title: "星际迷航：暗夜边界",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "欧美",
    year: 2025,
    rating: null,
    director: "摩根·雷耶斯",
    actors: ["李维·卡特", "艾米·陈", "丹尼尔·福斯特"],
    synopsis: "一支远征舰队穿越虫洞抵达宇宙暗夜边界，船员们必须在能源耗尽前解开一段远古文明留下的坐标之谜，而舱外那片死寂的黑暗，正缓缓睁开双眼。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20lone%20astronaut%20silhouette%20before%20a%20vast%20glowing%20wormhole%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-01&orientation=portrait",
    popularity: 9860,
    releaseDate: "2025-09-18",
    topics: ["annual-blockbusters", "sci-fi-worlds"],
  },
  {
    id: "changan-night",
    title: "长安幻夜",
    type: "movie",
    genres: ["古装", "奇幻"],
    region: "大陆",
    year: 2025,
    rating: null,
    director: "顾长风",
    actors: ["沈砚之", "白清歌", "陆归尘"],
    synopsis: "上元灯会之夜，长安城上空浮现出一座倒悬的幻城。少年画师与捉妖司女捕头携手入局，在流光与谎言之间，揭开一场横跨三百年的人妖之约。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20ancient%20Chinese%20lantern%20city%20at%20night%20with%20a%20floating%20inverted%20palace%20above%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-02&orientation=portrait",
    popularity: 9410,
    releaseDate: "2025-08-30",
    topics: ["annual-blockbusters", "costume-epics"],
  },
  {
    id: "chasing-wind",
    title: "追风者",
    type: "movie",
    genres: ["动作", "犯罪"],
    region: "大陆",
    year: 2024,
    rating: null,
    director: "韩启明",
    actors: ["雷震东", "苏晚晴", "周牧野"],
    synopsis: "曾经的赛车冠军隐姓埋名成为代驾司机，直到一桩连环劫案把他重新逼回驾驶座。为了洗清冤屈，他必须在城市的霓虹与暴雨里，跑赢时间，也跑赢自己。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20rain%20soaked%20neon%20city%20street%20with%20a%20speeding%20car%20and%20motion%20blur%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-03&orientation=portrait",
    popularity: 7230,
    releaseDate: "2024-11-22",
    topics: ["annual-blockbusters"],
  },
  {
    id: "deep-sea-echo",
    title: "深海回声",
    type: "movie",
    genres: ["科幻", "悬疑"],
    region: "大陆",
    year: 2025,
    rating: null,
    director: "陆离",
    actors: ["江湛", "林知夏", "何书远"],
    synopsis: "万米海沟之下，深潜器接收到一段不该存在的呼救信号，而信号的发送者，正是三年前失踪的科考队长。真相沉在黑暗里，越往下潜，越接近一个被刻意淹没的秘密。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20deep%20sea%20submersible%20descending%20into%20an%20abyssal%20trench%20with%20a%20faint%20glow%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-04&orientation=portrait",
    popularity: 8760,
    releaseDate: "2025-07-11",
    topics: ["sci-fi-worlds"],
  },
  {
    id: "doomsday-dawn",
    title: "末日黎明",
    type: "movie",
    genres: ["科幻", "灾难"],
    region: "欧美",
    year: 2024,
    rating: null,
    director: "艾琳娜·沃斯",
    actors: ["马克·霍尔", "索菲亚·雷恩", "汤姆·贝利"],
    synopsis: "当太阳的最后一次耀斑吞没电网，一座避难城市依靠地下反应堆维持光明。工程师与救援队在秩序崩塌的倒计时里，寻找那束能让人类见到黎明的备用能源。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20ruined%20city%20silhouette%20under%20a%20burning%20red%20sky%20with%20a%20single%20beam%20of%20light%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-05&orientation=portrait",
    popularity: 6890,
    releaseDate: "2024-09-06",
    topics: ["annual-blockbusters", "sci-fi-worlds"],
  },
  {
    id: "gentle-lie",
    title: "温柔的谎言",
    type: "movie",
    genres: ["剧情", "爱情"],
    region: "日韩",
    year: 2025,
    rating: null,
    director: "朴敏俊",
    actors: ["金秀雅", "李在贤", "郑河恩"],
    synopsis: "一位失忆的钢琴家被陌生女子认作故人，两人在善意的谎言中重新学会相爱。当记忆逐渐归来，他们必须决定：爱真实的人，还是爱那个被想象出来的影子。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20rainy%20night%20window%20with%20a%20person%20playing%20piano%20and%20a%20soft%20glowing%20reflection%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-06&orientation=portrait",
    popularity: 6120,
    releaseDate: "2025-06-14",
    topics: ["asia-hits"],
  },
  {
    id: "dark-alley-detective",
    title: "暗巷侦探",
    type: "movie",
    genres: ["悬疑", "犯罪"],
    region: "欧美",
    year: 2024,
    rating: null,
    director: "亚瑟·布莱克",
    actors: ["休·道森", "克莱尔·摩尔", "本·哈特"],
    synopsis: "在永远见不到阳光的老城区，一名患有面孔失认症的私家侦探，依靠录音与线索破案。当他追踪一宗连环失踪案时，发现每个证人描述的凶手，都长得不一样。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20lone%20detective%20silhouette%20in%20a%20foggy%20narrow%20alley%20lit%20by%20a%20single%20streetlamp%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-07&orientation=portrait",
    popularity: 5980,
    releaseDate: "2024-10-18",
    topics: ["suspense-collection"],
  },
  {
    id: "shanhai-scroll",
    title: "山海绘卷",
    type: "movie",
    genres: ["奇幻", "冒险"],
    region: "大陆",
    year: 2025,
    rating: null,
    director: "顾长风",
    actors: ["叶知秋", "云三千", "白清歌"],
    synopsis: "古籍修复师意外打开一卷会呼吸的山海图，神兽循墨而出，祸及人间。为了封卷归位，她必须与被封印千年的守卷人一起，重绘那段被世人遗忘的上古契约。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20ancient%20mythical%20beasts%20emerging%20from%20a%20glowing%20ink%20scroll%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-08&orientation=portrait",
    popularity: 8340,
    releaseDate: "2025-05-01",
    topics: ["costume-epics", "sci-fi-worlds"],
  },
  {
    id: "song-chronicle",
    title: "大宋风云录",
    type: "tvshow",
    genres: ["历史", "古装"],
    region: "大陆",
    year: 2025,
    rating: null,
    director: "沈牧之",
    actors: ["赵允之", "范知微", "柳明昭", "陈抱朴"],
    synopsis: "剧集以一座边境州府为原点，讲述乱世之中一群文臣武将如何守城、守心、守约。庙堂的算计与江湖的义气交织，勾勒出一幅波澜壮阔的时代群像长卷。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20ancient%20Chinese%20fortress%20on%20a%20mountain%20pass%20under%20a%20dramatic%20sky%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-09&orientation=portrait",
    popularity: 9900,
    releaseDate: "2025-09-25",
    topics: ["chinese-drama-hits", "costume-epics"],
  },
  {
    id: "city-labyrinth",
    title: "都市迷局",
    type: "tvshow",
    genres: ["都市", "悬疑"],
    region: "大陆",
    year: 2024,
    rating: null,
    director: "程亦远",
    actors: ["顾言深", "温可可", "卢子墨"],
    synopsis: "一桩看似普通的商业诈骗案，牵出一张覆盖整座城市的暗网。年轻检察官与记者搭档追查真相，却发现每一个关键证人，都在说出真相前巧妙失忆。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20modern%20glass%20office%20towers%20at%20dusk%20with%20a%20lone%20figure%20silhouette%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-10&orientation=portrait",
    popularity: 7460,
    releaseDate: "2024-12-03",
    topics: ["chinese-drama-hits", "suspense-collection"],
  },
  {
    id: "sakura-promise",
    title: "樱花之约",
    type: "tvshow",
    genres: ["爱情", "剧情"],
    region: "日韩",
    year: 2025,
    rating: null,
    director: "佐藤悠介",
    actors: ["小林遥", "山田凉", "井上葵"],
    synopsis: "约定在樱花树下重逢的两个人，被一场误会隔开了七年。当女主带着未寄出的信回到小镇，男主却已成了那棵樱花的守护者。这一次，他们决定不再错过花期。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20two%20figures%20under%20a%20blooming%20cherry%20blossom%20tree%20at%20golden%20hour%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-11&orientation=portrait",
    popularity: 7020,
    releaseDate: "2025-04-12",
    topics: ["asia-hits"],
  },
  {
    id: "game-of-power",
    title: "权力的棋局",
    type: "tvshow",
    genres: ["剧情", "政治"],
    region: "欧美",
    year: 2024,
    rating: null,
    director: "詹姆斯·科尔",
    actors: ["理查德·格兰特", "海伦·肖", "大卫·斯特恩"],
    synopsis: "一场改选让首都的权力天平骤然倾斜。理想主义的年轻议员被迫卷入党派与资本的博弈，他发现棋盘上每一步都早已被别人写好，除了最后那一步。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20grand%20marble%20capitol%20hall%20with%20a%20lone%20figure%20before%20a%20chessboard%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-12&orientation=portrait",
    popularity: 6540,
    releaseDate: "2024-08-20",
    topics: ["annual-blockbusters"],
  },
  {
    id: "jianghu-lantern",
    title: "江湖夜雨十年灯",
    type: "tvshow",
    genres: ["武侠", "古装"],
    region: "大陆",
    year: 2025,
    rating: null,
    director: "燕十三",
    actors: ["萧别离", "苏眉", "沈孤鸿"],
    synopsis: "十年前一场灭门血案，让少年剑客背井离乡。如今他持一柄旧剑重返江湖，只为讨一个公道，却在仇人的灯下，遇见了当年那个本该死去的自己。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20swordsman%20in%20rain%20before%20a%20glowing%20lantern%20in%20an%20ancient%20alley%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-13&orientation=portrait",
    popularity: 9180,
    releaseDate: "2025-08-08",
    topics: ["chinese-drama-hits", "costume-epics"],
  },
  {
    id: "future-epoch",
    title: "未来纪元",
    type: "tvshow",
    genres: ["科幻"],
    region: "欧美",
    year: 2025,
    rating: null,
    director: "诺亚·陈",
    actors: ["凯文·张", "艾丽丝·王", "里奥·马丁"],
    synopsis: "在意识可以被上传的未来，人类为争抢有限的『云端永生』名额，建立起一套冰冷的评分制度。一名低分青年意外获得顶级账号，从此开始了一场关于尊严与自由的反击。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20futuristic%20neon%20megacity%20with%20glowing%20data%20streams%20and%20a%20lone%20figure%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-14&orientation=portrait",
    popularity: 8970,
    releaseDate: "2025-07-30",
    topics: ["sci-fi-worlds", "annual-blockbusters"],
  },
  {
    id: "white-night-doctor",
    title: "白夜医者",
    type: "tvshow",
    genres: ["医疗", "剧情"],
    region: "日韩",
    year: 2024,
    rating: null,
    director: "车志勋",
    actors: ["韩世妍", "姜泰州", "尹素罗"],
    synopsis: "一家 24 小时不熄灯的急诊室，见证着城市最脆弱也最顽强的时刻。年轻的女主治在生死之间反复抉择，也在一次次告别里，重新理解了医者的重量。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20emergency%20room%20corridor%20glowing%20late%20at%20night%20with%20a%20doctor%20silhouette%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-15&orientation=portrait",
    popularity: 6310,
    releaseDate: "2024-11-05",
    topics: ["asia-hits"],
  },
  {
    id: "campus-youth",
    title: "校园青春纪事",
    type: "tvshow",
    genres: ["青春", "校园"],
    region: "大陆",
    year: 2023,
    rating: null,
    director: "孟小舟",
    actors: ["林一诺", "周予安", "徐嘉树"],
    synopsis: "高三最后一年，五个性格迥异的少年在同一个教室里并肩冲刺。友情、暗恋与梦想在倒计时的粉笔灰里发酵，他们约定：无论去往哪里，都要记得此刻的风。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20golden%20hour%20school%20classroom%20with%20warm%20sunlight%20through%20windows%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-16&orientation=portrait",
    popularity: 5230,
    releaseDate: "2023-09-15",
    topics: ["chinese-drama-hits"],
  },
  {
    id: "island-mist",
    title: "孤岛疑云",
    type: "movie",
    genres: ["悬疑", "惊悚"],
    region: "欧美",
    year: 2024,
    rating: null,
    director: "奥利维亚·格林",
    actors: ["彼得·劳森", "安娜·凯", "米娅·邓恩"],
    synopsis: "六位陌生人受邀登上无人岛参加一场心理实验，却在第一夜发现唯一的返航船只被毁。当他们试图拼凑彼此的记忆时，才意识到真正的囚笼从来不是这座岛。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20isolated%20lighthouse%20on%20a%20stormy%20rocky%20island%20with%20heavy%20fog%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-17&orientation=portrait",
    popularity: 5870,
    releaseDate: "2024-07-19",
    topics: ["suspense-collection"],
  },
  {
    id: "star-legion-dawn",
    title: "星河战队：黎明",
    type: "movie",
    genres: ["科幻", "动作"],
    region: "欧美",
    year: 2023,
    rating: null,
    director: "雷·西蒙斯",
    actors: ["杰克·罗", "娜塔莉·冯", "卡尔·李"],
    synopsis: "人类最后的舰队在银河边缘集结，准备迎接一场决定文明存亡的决战。一队被遗忘的工程兵，却在废弃星港里发现了能够改变战局的秘密武器，也发现了敌人的真正目的。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%2C%20armored%20soldiers%20before%20a%20giant%20spaceship%20in%20a%20star%20field%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-18&orientation=portrait",
    popularity: 7660,
    releaseDate: "2023-12-08",
    topics: ["sci-fi-worlds", "annual-blockbusters"],
  },
  {
    id: "ancient-mirror-tales",
    title: "古镜奇谈",
    type: "tvshow",
    genres: ["奇幻", "悬疑"],
    region: "大陆",
    year: 2024,
    rating: null,
    director: "蒲若言",
    actors: ["辛夷", "裴照", "阿宁"],
    synopsis: "一面流落民间的青铜古镜，能照出人心中最不愿面对的过往。每当镜中人影浮现，城中便多一桩诡案。捕快与镜灵被迫结盟，追查藏在镜面背后的执念与真相。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20ornate%20ancient%20bronze%20mirror%20glowing%20in%20a%20dark%20room%20with%20mist%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-19&orientation=portrait",
    popularity: 6980,
    releaseDate: "2024-06-21",
    topics: ["chinese-drama-hits", "suspense-collection"],
  },
  {
    id: "north-legend",
    title: "北境传说",
    type: "tvshow",
    genres: ["冒险", "奇幻"],
    region: "欧美",
    year: 2023,
    rating: null,
    director: "艾瑞克·诺兰",
    actors: ["比约恩·哈根", "弗蕾亚·林德", "奥拉夫·斯文"],
    synopsis: "在被永冬笼罩的北境，最后一位符文师踏上寻找世界之树的旅程。他背负着村庄的希望，也背负着一段被冰封千年的预言，而极光之下，古老的巨兽正在苏醒。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20artwork%2C%20lone%20wanderer%20crossing%20a%20frozen%20northern%20landscape%20under%20aurora%20lights%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20moody%20premium%20mood%2C%20no%20typography&width=600&height=900&seq=poster-20&orientation=portrait",
    popularity: 5420,
    releaseDate: "2023-10-27",
    topics: ["annual-blockbusters", "costume-epics"],
  },
];